import InputTypesEnum from '../../../Enums/InputTypesEnum';
import PlanningDetailsItemService from '../../../Services/PlanningDetailsItemService';
import PlanningStatusEnum from '../../../Enums/PlanningStatusEnum';
import statusHelper from '../../../Helpers/statusHelper';
import stringHelper from '../../../Helpers/stringHelper';
import dateTimeHelper from '../../../Helpers/datetimeHelper';
import PlanningDetailStatusUpdateItem from '../../../Domain/PlanningDetailStatusUpdateItem';
import PlanningCancellationDecisionEnum from '../../../Enums/PlanningCancellationDecisionEnum';
import PlanningCancellationDecisionOptionsArray from '../../../Enums/PlanningCancellationDecisionOptionsArray';

const buildTitle = (item) =>
  item && item.IsSingle ? 'PlanningDetail Item - Update Status' : 'PlanningDetail Mass Status Update';

const buildSuccessMessage = (item) =>
  item && item.IsSingle
    ? 'The status of the PlanningDetail Item has been updated.'
    : 'The status of the selected PlanningDetail Items has been updated.';

const buildSingleContext = (item) => {
  const paragraphs = [
    `Id: ${item.PlanningDetailId}, Fieldwork Period: ${item.FieldworkOrderNumber}, ${dateTimeHelper.toYYYYsMMsDD(
      item.StartDate
    )} - ${dateTimeHelper.toYYYYsMMsDD(item.EndDate)}`,
    `Current status: **${stringHelper.convertToWords(item.CurrentStatus).trim()}**`,
  ];
  if (item.CurrentStatus === PlanningStatusEnum.Cancelled && item.CurrentCancellationDecision) {
    paragraphs.push(
      `Cancellation: ${item.CurrentCancellationDecision}${
        item.CurrentCancellationComment ? ` — ${item.CurrentCancellationComment}` : ''
      }`
    );
  }
  if (item.CurrentStatus === PlanningStatusEnum.Closed) {
    if (item.IsAdmin) {
      paragraphs.push('Nyugi, Tamás!', 'Csak az adminok tudnak Closed státuszt OnHoldra tenni!');
      return { paragraphs, imageSrc: '/img/user/vecseitamas-small.jpg', imageAlt: '' };
    }
    paragraphs.push("The status of this PlanningDetail can't be changed.");
  }
  const dateLockNote = statusHelper.getDateLockNote(item.To);
  if (dateLockNote) {
    paragraphs.push(dateLockNote);
  }
  return { paragraphs };
};

export default class PlanningDetailStatusUpdateWindowDescription {
  static titleForCreate = buildTitle;
  static titleForEdit = buildTitle;
  static itemType = PlanningDetailStatusUpdateItem;
  static messageOnSuccess = buildSuccessMessage;

  static approveBeforeSaveCheck = (item) =>
    item.To === PlanningStatusEnum.Closed || item.To === PlanningStatusEnum.Cancelled;
  static approveBeforeSaveMessage = "You won't be able to go back. Are you sure?";

  static serviceFunction = (item) =>
    PlanningDetailsItemService.MassStatusUpdate(item.Ids, item.To, item.CancellationDecision, item.CancellationComment);

  static pagesInGeneralEditWizzard = [
    {
      fields: [
        {
          fieldName: 'StatusInfo',
          label: '',
          className: 'col-6',
          type: InputTypesEnum.InfoCallout,
          buildContent: (item) =>
            item.IsSingle ? buildSingleContext(item) : { paragraphs: statusHelper.getFromInfoParagraphs(item.To) },
        },
        {
          fieldName: 'To',
          label: 'To',
          className: 'col-6',
          type: InputTypesEnum.Select,
          selectvalues: (item) =>
            item.IsSingle
              ? // Single items default To to '' to force an explicit pick; a native <select> with an
                // unmatched value would otherwise display the first real option while the value stays
                // empty, so prepend a disabled placeholder that matches the empty default.
                [
                  { label: 'Select a status...', value: '', disabled: true },
                  ...statusHelper.getToSelectValuesForItem(item, item.IsAdmin),
                ]
              : statusHelper.getToSelectValues(),
          validityChecker: (value, item) => {
            if (!value) return 'Please select a status.';
            if (
              item &&
              item.IsSingle &&
              (value === PlanningStatusEnum.Closed ||
                value === PlanningStatusEnum.ClientConfirmed ||
                value === PlanningStatusEnum.OnField) &&
              !(item.NumberOfPlannedAssignments > 0)
            ) {
              return 'This item has 0 planned assignments. Set a planned assignment count greater than 0 before confirming, sending it to field or closing it.';
            }
            return '';
          },
        },
        {
          fieldName: 'CancellationDecision',
          label: 'Cancellation Decision',
          className: 'col-12',
          type: InputTypesEnum.PillSelect,
          selectvalues: PlanningCancellationDecisionOptionsArray,
          hide: (item) => item.To !== PlanningStatusEnum.Cancelled,
          validityChecker: (value) => (value ? '' : 'Please select a cancellation decision.'),
        },
        {
          fieldName: 'CancellationComment',
          label: 'Comment',
          className: 'col-12',
          type: InputTypesEnum.TextBox,
          numberOfRows: 3,
          hide: (item) =>
            item.To !== PlanningStatusEnum.Cancelled ||
            item.CancellationDecision !== PlanningCancellationDecisionEnum.Other,
          validityChecker: (value) => (value && value.trim() ? '' : 'Please enter a comment.'),
        },
      ],
    },
  ];
}
